import {
  DEFAULT_INITIAL_STATE,
  InitialStateProps,
  ModeWithSceneFilterInitialState,
} from "@/modes/mode";
import { selectFlyWalkSceneFilter } from "@/store/modes/flywalk-mode-slice";
import { SceneFilter } from "@/types/scene-filter";
import {
  GUID,
  includes,
  PropOptional,
  validatePrimitive,
} from "@faro-lotv/foundation";

/** An object to compute and parse a state object to create and restore the fly walk mode states from deep links */
export const FLY_WALK_MODE_INITIAL_STATE: InitialStateProps<ModeWithSceneFilterInitialState> =
  {
    compute(state, viewContext) {
      return {
        ...DEFAULT_INITIAL_STATE.compute(state, viewContext),
        scene: selectFlyWalkSceneFilter(state),
      };
    },
    parse(appState, modeState) {
      let lookAtId: GUID | undefined;
      const scene = includes(Object.values(SceneFilter), modeState.scene)
        ? modeState.scene
        : undefined;
      // lookAtId is not defined when coming back from the Draft view, so no error should be
      // logged for this standard case.
      if (validatePrimitive(modeState, "lookAtId", "string", PropOptional)) {
        ({ lookAtId } = modeState);
      }
      return {
        ...DEFAULT_INITIAL_STATE.parse(appState, modeState),
        scene,
        lookAtId,
      };
    },
  };
